import { RatePeriodModel } from '@utmost.co/enterprise-models';

export const RATE_CARD_FREQUENCY: {
  label: string;
  value: RatePeriodModel;
  id: string;
}[] = [
  { label: 'Hourly', value: 'HOURLY', id: 'HOURLY' },
  { label: 'Daily', value: 'DAILY', id: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY', id: 'WEEKLY' },
  { label: 'Biweekly', value: 'BI_WEEKLY', id: 'BI_WEEKLY' },
  { label: 'Monthly', value: 'MONTHLY', id: 'MONTHLY' },
  { label: 'On invoice', value: 'ON_INVOICE', id: 'ON_INVOICE' }
];

export enum RATE_CARD_FIELDS {
  NAME = 'rateCard.name',
  CODE = 'rateCard.referenceCode',
  CURRENCY = 'rateCard.currency.code',
  LOCATION = 'rateCard.businessSiteOverrides',
  REMOTE_WORK_ADDRESS = 'rateCard.remoteWorkAddress',
  FREQUENCY = 'rateCard.frequency',
  DEFAULT_BILL_RATE_MIN = 'rateCard.billRate.min',
  DEFAULT_BILL_RATE_MAX = 'rateCard.billRate.max',
  DEFAULT_PAY_RATE_MIN = 'rateCard.payRate.min',
  DEFAULT_PAY_RATE_MAX = 'rateCard.payRate.max',
  DEFAULT_MARKUP = 'rateCard.markup',
  OVER_TIME_BILL_RATE = 'rateCard.overTimeRateInfo.billRate',
  OVER_TIME_PAY_RATE = 'rateCard.overTimeRateInfo.payRate',
  OVER_TIME_MARKUP = 'rateCard.overTimeRateInfo.markup',
  DOUBLE_TIME_BILL_RATE = 'rateCard.doubleTimeRateInfo.billRate',
  DOUBLE_TIME_PAY_RATE = 'rateCard.doubleTimeRateInfo.payRate',
  DOUBLE_TIME_MARKUP = 'rateCard.doubleTimeRateInfo.markup',
  SHIFT_BILL_RATE = 'rateCard.shiftRateInfo.billRate',
  SHIFT_PAY_RATE = 'rateCard.shiftRateInfo.payRate',
  SHIFT_FACTOR = 'rateCard.shiftRateInfo.factor',
  JOB_PROFILE = 'primaryEngagement.jobProfile',
  SUPPLIER = 'primaryEngagement.supplier'
}
